import { render, staticRenderFns } from "./users_list.vue?vue&type=template&id=77c37794"
import script from "./users_list.vue?vue&type=script&lang=js"
export * from "./users_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports